import { FirebaseApp } from 'firebase/app';
import type { Analytics } from 'firebase/analytics';

/** 啟用 GA 的環境，其餘環境不送任何事件 */
const ANALYTICS_ENABLED_ENVS = ['dev', 'uat', 'release'];

let analytics: Analytics | null = null;
let logEventFn: typeof import('firebase/analytics').logEvent | null = null;

// 不 import firebase.ts，由 firebase.ts 初始化 app 後傳入，避免改變既有模組載入順序
export const initAnalytics = async (app: FirebaseApp) => {
  if (!ANALYTICS_ENABLED_ENVS.includes(import.meta.env.VITE_ENV)) return;

  // 用動態載入：擋廣告外掛會擋掉檔名含 analytics 的檔案，
  // 靜態 import 被擋會讓整個 App 白畫面，動態載入失敗則只是不送事件
  try {
    const { getAnalytics, isSupported, logEvent } = await import(
      'firebase/analytics'
    );
    if (!(await isSupported())) return;
    analytics = getAnalytics(app);
    logEventFn = logEvent;
  } catch {
    analytics = null;
    logEventFn = null;
  }
};

/**
 * 參數名稱要註冊成 GA 自訂維度才能在報表分組，每個資源上限 50 個。各功能埋點優先
 * 沿用共用參數名稱，用事件名稱區分功能，只有該功能獨有的概念才另取名稱：
 * - mode：使用的方式／類型
 * - entry：進入方式（create／copy／edit…）
 * - type：彈窗或提示的種類
 * - action：使用者按下的動作
 * - error_code：錯誤代碼
 * - source_status：來源資料的狀態
 * - duration_sec：花費秒數（自訂指標）
 */
export const trackEvent = (
  eventName: string,
  params?: Record<string, string | number | boolean>,
) => {
  if (!analytics || !logEventFn) return;
  logEventFn(analytics, eventName, params);
};
